<report-filter
showCostCenters='true'
showFacilities='true'
showPeriodEndDateSelection='true'
showShiftBlocks='true'
showViews='true'
defaultPayPeriodsBack=1
defaultView='Date'
reportType='ancillary'
ancillaryType='total'
[(defaultFilter)]="filters"
(filterUpdated)="filterUpdated($event)"
[(views)]="views">
</report-filter>

<smt-performancereport
[filtersUpdated]='filterEventsSubject.asObservable()'
(performanceDataUpdated)='performanceDataUpdated($event)'
[(reportFilters)]='filters'>
</smt-performancereport>

<report-export-button
[reportFilters]="filters"
[exportUrl]="'TotalUosReport/GetTotalUOSPerformanceReportExportData'"
[fileName]="'TotalUOS_Performance_Report'"
[filtersUpdated]='filterEventsSubject.asObservable()'>
</report-export-button>

<table class="condensed" role="list" *ngIf="performanceData.gridInformation">
<colgroup>
  <col class="medium-filter-column">
  <col class="medium-filter-column">
  <col class="medium-filter-column">
  <col class="medium-filter-column">
  <col class="medium-filter-column">
  <col class="medium-filter-column">
  <col class="medium-filter-column">
</colgroup>
<thead>
  <th align="left">Date</th>
  <th align="left">UOS Type</th>
  <th align="left">UOS</th>
  <th align="left">WHPUOS</th>
  <th align="left">Target Worked Hours</th>
  <th align="left">Worked Hours</th>
  <th align="left">Hours Variance</th>
  <th align="left">Productivity Percent</th>
</thead>
<tr *ngFor="let item of performanceData.gridInformation">
  <td>{{item.fieldName}}</td>
  <td>{{item.category}}</td>
  <td>{{formatValue(item.uos)}}</td>
  <td>{{item.whpuos ? formatValue(item.whpuos) : '-'}}</td>
  <td>{{formatValue(item.targetWorkedHours)}}</td>
  <td>{{formatValue(item.workedHours)}}</td>
  <td>{{formatValue(item.variance)}}</td>
  <td>{{item.productivityPercent ? formatValue(item.productivityPercent, 0) + '%' : '-'}}</td>
</tr>
</table>
